module.exports = __webpack_public_path__ + "static/img/GooglePlay.0bc6b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/softwares/GooglePlay.png
// module id = 6DMh
// module chunks = 6